export const SeachQueries = [
  {
    title: "Maruti Suzuki",

    url: `/cat${"/maruti_suzuki"}`,
  },

  {
    title: "Omni",
    url: `/category${"/maruti_suzuki/omni"}`,

    cName: "sub-nav",
  },
  {
    title: "Ignis",
    url: `/category${"/maruti_suzuki/ignis"}`,

    cName: "sub-nav",
  },
  {
    title: "Eeco",
    url: `/category${"/maruti_suzuki/eeco"}`,

    cName: "sub-nav",
  },
  {
    title: "Dzire",
    url: `/category${"/maruti_suzuki/dzire"}`,

    cName: "sub-nav",
  },
  {
    title: "Ciaz",
    url: `/category${"/maruti_suzuki/ciaz"}`,

    cName: "sub-nav",
  },
  {
    title: "Alto K10",
    url: `/category${"/maruti_suzuki/alto_k10"}`,

    cName: "sub-nav",
  },
  {
    title: "Alto",
    url: `/category${"/maruti_suzuki/alto"}`,

    cName: "sub-nav",
  },
  {
    title: "Eeco",
    url: `/category${"/maruti_suzuki/eeco"}`,
  },
  {
    title: "Ertiga",
    url: `/category${"/maruti_suzuki/ertiga"}`,
  },
  {
    title: "Ritz",
    url: `/category${"/maruti_suzuki/ritz"}`,
  },
  {
    title: "Swift",
    url: `/category${"/maruti_suzuki/swift"}`,
  },
  {
    title: "Vitara",
    url: `/category${"/maruti_suzuki/vitara"}`,
  },
  {
    title: "WagonR",
    url: `/category${"/maruti_suzuki/wagonr"}`,
  },
  {
    title: "Other Maruti Suzuki",
    url: `/category${"/maruti_suzuki/other_maruti_suzuki"}`,
  },
  ,
  {
    title: "Hyundai",

    url: `/cat${"/hyundai"}`,
  },

  {
    title: "Eon",
    url: `/category${"/hyundai/eon"}`,

    cName: "sub-nav",
  },

  {
    title: "Elantra",
    url: `/category${"/hyundai/elantra"}`,

    cName: "sub-nav",
  },
  {
    title: "Grand i10",
    url: `/category${"/hyundai/grand_i10"}`,
  },
  {
    title: "i20",
    url: `/category${"/hyundai/i20"}`,
  },
  {
    title: "Santro xing",
    url: `/category${"/hyundai/santro_xing"}`,
  },
  {
    title: "Verna",
    url: `/category${"/hyundai/verna"}`,
  },

  {
    title: "Creta",
    url: `/category${"/hyundai/creta"}`,
  },
  {
    title: "Elite i20",
    url: `/category${"/hyundai/elite_i20"}`,
  },
  {
    title: "i20 Active",
    url: `/category${"/hyundai/i20_active"}`,
  },
  {
    title: "Venue",
    url: `/category${"/hyundai/venue"}`,
  },
  {
    title: "Xcent",
    url: `/category${"/hyundai/xcent"}`,
  },
  {
    title: "other Hyundai",
    url: `/category${"/hyundai/other_hyundai"}`,
  },

  {
    title: "Honda",

    url: `/cat${"/honda"}`,
  },

  {
    title: "Civic",
    url: `/category${"/honda/civic"}`,
    suburl: "civic",

    cName: "sub-nav",
  },
  {
    title: "CR-V",
    suburl: "cr-v",
    url: `/category${"/honda/cr-v"}`,

    cName: "sub-nav",
  },
  {
    title: "HR-V",
    suburl: "hrv",
    url: `/category${"/honda/hr-v"}`,
  },

  {
    title: "W-RV",
    suburl: "w-rv",
    url: `/category${"/honda/w-rv"}`,
  },
  {
    title: "City",
    suburl: "city",
    url: `/category${"/honda/city"}`,
  },

  {
    title: "Accord",
    suburl: "accord",
    url: `/category${"/honda/accord"}`,
  },
  {
    title: "Amaze",
    suburl: "amaze",
    url: `/category${"/honda/amaze"}`,
  },
  {
    title: "Jazz",
    suburl: "jazz",
    url: `/category${"/honda/jazz"}`,
  },
  {
    title: "other Honda",
    suburl: "other_honda",
    url: `/category${"/honda/other_honda"}`,
  },

  {
    title: "Toyota",
    url: `/cat${"/toyota"}`,
    // url: "/reports",
  },
  {
    title: "Etios",
    suburl: "etios",
    url: `/category${"/toyota/etios"}`,

    cName: "sub-nav",
  },

  {
    title: "Glanza",
    suburl: "glanza",
    url: `/category${"/toyota/glanza"}`,

    cName: "sub-nav",
  },

  {
    title: "Yaris",
    suburl: "yaris",
    url: `/category${"/toyota/yaris"}`,

    cName: "sub-nav",
  },
  {
    title: "Innova Crysta",
    suburl: "innova_crysta",
    url: `/category${"/toyota/innova_crysta"}`,

    cName: "sub-nav",
  },
  {
    title: "Etios Liva",
    suburl: "etios_liva",
    url: `/category${"/toyota/etios_liva"}`,

    cName: "sub-nav",
  },
  {
    title: "Etios Cross",
    suburl: "etios_cross",
    url: `/category${"/toyota/etios_cross"}`,

    cName: "sub-nav",
  },
  {
    title: "Corolla Altis",
    suburl: "corolla_altis",
    url: `/category${"/toyota/corolla_altis"}`,

    cName: "sub-nav",
  },
  {
    title: "Fortuner",
    suburl: "fortuner",
    url: `/category${"/toyota/fortuner"}`,

    cName: "sub-nav",
  },
  {
    title: "Camry",
    suburl: "camry",
    url: `/category${"/toyota/camry"}`,

    cName: "sub-nav",
  },
  {
    title: "Innova",
    suburl: "innova",
    url: `/category${"/toyota/innova"}`,

    cName: "sub-nav",
  },
  {
    title: "Other Toyota",
    url: `/category${"/toyota/other_toyota"}`,
  },

  {
    title: "Tata",

    url: `/cat${"/tata"}`,
  },
  {
    title: "Zest",
    suburl: "zest",
    url: `/category${"/tata/zest"}`,

    cName: "sub-nav",
  },
  {
    title: "Tigor",
    suburl: "tigor",
    url: `/category${"/tata/tigor"}`,

    cName: "sub-nav",
  },
  {
    title: "Tiago",
    suburl: "tiago",
    url: `/category${"/tata/tiago"}`,

    cName: "sub-nav",
  },
  {
    title: "Safari Storme",
    suburl: "safari_storme",
    url: `/category${"/tata/safari_storme"}`,

    cName: "sub-nav",
  },
  {
    title: "Nexon",
    suburl: "nexon",
    url: `/category${"/tata/nexon"}`,

    cName: "sub-nav",
  },
  {
    title: "Hexa",
    suburl: "hexa",
    url: `/category${"/tata/hexa"}`,

    cName: "sub-nav",
  },
  {
    title: "Harrier",
    suburl: "harrier",
    url: `/category${"/tata/harrier"}`,

    cName: "sub-nav",
  },
  {
    title: "Bolt",
    suburl: "bolt",
    url: `/category${"/tata/bolt"}`,

    cName: "sub-nav",
  },
  {
    title: "Indica",
    suburl: "indica",
    url: `/category${"/tata/indica"}`,

    cName: "sub-nav",
  },
  {
    title: "Nano",
    suburl: "nano",
    url: `/category${"/tata/nano"}`,

    cName: "sub-nav",
  },
  {
    title: "Other Tata",
    suburl: "other_tata",
    url: `/category${"/tata/other_tata"}`,
  },

  {
    title: "Mahindra",
    url: "mahindra",
  },
  {
    title: "Thar",
    suburl: "thar",
    url: `/category${"/mahindra/thar"}`,

    cName: "sub-nav",
  },
  {
    title: "TUV 300",
    suburl: "tuv_300",
    url: `/category${"/mahindra/tuv_300"}`,

    cName: "sub-nav",
  },
  {
    title: "KUV 100",
    suburl: "kuv_100",
    url: `/category${"/mahindra/kuv_100"}`,

    cName: "sub-nav",
  },
  {
    title: "Bolero",
    suburl: "bolero",
    url: `/category${"/mahindra/bolero"}`,

    cName: "sub-nav",
  },
  {
    title: "XUV500",
    suburl: "xuv500",
    url: `/category${"/mahindra/xuv500"}`,

    cName: "sub-nav",
  },
  {
    title: "Xylo",
    suburl: "xylo",
    url: `/category${"/mahindra/xylo"}`,

    cName: "sub-nav",
  },
  {
    title: "Other Mahindra",
    suburl: "other_mahindra",
    url: `/category${"/mahindra/other_mahindra"}`,

    cName: "sub-nav",
  },

  {
    title: "Volkswagen",

    url: `/cat${"/volkswagen"}`,
  },
  {
    title: "Polo",
    suburl: "polo",
    url: `/category${"/volkswagen/polo"}`,

    cName: "sub-nav",
  },

  {
    title: "Veno",
    suburl: "veno",
    url: `/category${"/volkswagen/veno"}`,

    cName: "sub-nav",
  },
  {
    title: "Tiguan",
    suburl: "tiguan",
    url: `/category${"/volkswagen/tiguan"}`,

    cName: "sub-nav",
  },
  {
    title: "T-Roc",
    suburl: "t-roc",
    url: `/category${"/volkswagen/t-roc"}`,

    cName: "sub-nav",
  },
  {
    title: "Ameo",
    suburl: "ameo",
    url: `/category${"/volkswagen/ameo"}`,

    cName: "sub-nav",
  },
  {
    title: "Golf",
    suburl: "golf",
    url: `/category${"/volkswagen/golf"}`,

    cName: "sub-nav",
  },
  {
    title: "Other Volkswagen",
    suburl: "other_volkswagen",
    url: `/category${"/volkswagen/other_volkswagen"}`,

    cName: "sub-nav",
  },

  {
    title: "Kia",

    url: `/cat${"/kia"}`,
  },
  {
    title: "Ceed",
    suburl: "ceed",
    url: `/category${"/kia/ceed"}`,

    cName: "sub-nav",
  },

  {
    title: "Sonet",
    suburl: "sonet",
    url: `/category${"/kia/sonet"}`,

    cName: "sub-nav",
  },
  {
    title: "Seltos",
    suburl: "seltos",
    url: `/category${"/kia/seltos"}`,

    cName: "sub-nav",
  },
  {
    title: "Carnival",
    suburl: "carnival",
    url: `/category${"/kia/carnival"}`,

    cName: "sub-nav",
  },
  {
    title: "Cerato",
    suburl: "cerato",
    url: `/category${"/kia/cerato"}`,

    cName: "sub-nav",
  },
  {
    title: "Cerato Sport",
    suburl: "cerato_sport",
    url: `/category${"/kia/cerato_sport"}`,

    cName: "sub-nav",
  },
  {
    title: "Other Kia",
    suburl: "other_kia",
    url: `/category${"/kia/other_kia"}`,

    cName: "sub-nav",
  },

  {
    title: "Mercedes Benz",

    url: `/cat${"/mercedes_benz"}`,
  },
  {
    title: "C Class",
    suburl: "c_class",
    url: `/category${"/mercedes_benz/c_class"}`,

    cName: "sub-nav",
  },
  {
    title: "E Class",
    suburl: "e_class",
    url: `/category${"/mercedes_benz/e_class"}`,

    cName: "sub-nav",
  },
  {
    title: "G Class",
    suburl: "g_class",
    url: `/category${"/mercedes_benz/g_class"}`,

    cName: "sub-nav",
  },
  {
    title: "Other Mercedes Benz",
    suburl: "other_mercedes_benz",
    url: `/category${"/mercedes_benz/other_mercedes_benz"}`,

    cName: "sub-nav",
  },

  {
    title: "Citroen",

    url: `/cat${"/citroen"}`,
  },
  {
    title: "C3",
    suburl: "c3",
    url: `/category${"/citroen/c3"}`,

    cName: "sub-nav",
  },
  {
    title: "C4",
    suburl: "c4",
    url: `/category${"/citroen/c4"}`,

    cName: "sub-nav",
  },
  {
    title: "C5",
    suburl: "c5",
    url: `/category${"/citroen/c5"}`,

    cName: "sub-nav",
  },
  {
    title: "Other Citroen",
    suburl: "other_citroen",
    url: `/category${"/citroen/other_citroen"}`,

    cName: "sub-nav",
  },

  {
    title: "BMW",
    url: `/cat${"/bmw"}`,
  },
  {
    title: "7 Series",
    suburl: "7_series",
    url: `/category${"/bmw/7_series"}`,

    cName: "sub-nav",
  },
  {
    title: "5 Series",
    suburl: "5_series",
    url: `/category${"/bmw/5_series"}`,

    cName: "sub-nav",
  },
  {
    title: "3 Series GT",
    suburl: "3_series_gt",
    url: `/category${"/bmw/3_series_gt"}`,

    cName: "sub-nav",
  },

  {
    title: "3 Series",
    suburl: "3_series",
    url: `/category${"/bmw/3_series"}`,

    cName: "sub-nav",
  },
  {
    title: "X1",
    suburl: "x1",
    url: `/category${"/bmw/x1"}`,

    cName: "sub-nav",
  },
  {
    title: "X3",

    suburl: "x3",

    url: `/category${"/bmw/x3"}`,

    cName: "sub-nav",
  },
  {
    title: "X4",

    suburl: "x4",

    url: `/category${"/bmw/x4"}`,

    cName: "sub-nav",
  },
  {
    title: "X5",

    suburl: "x5",

    url: `/category${"/bmw/x5"}`,

    cName: "sub-nav",
  },
  {
    title: "X6",

    suburl: "x6",

    url: `/category${"/bmw/x6"}`,

    cName: "sub-nav",
  },
  {
    title: "Other BMW",
    suburl: "other_bmw",
    url: `/category${"/bmw/other_bmw"}`,

    cName: "sub-nav",
  },

  {
    title: "Skoda",
    url: `/cat${"/skoda"}`,
  },
  {
    title: "Octavia",
    suburl: "octavia",
    url: `/category${"/skoda/octavia"}`,

    cName: "sub-nav",
  },
  {
    title: "Rapid",
    suburl: "rapid",
    url: `/category${"/skoda/rapid"}`,

    cName: "sub-nav",
  },
  {
    title: "Superb",
    suburl: "superb",
    url: `/category${"/skoda/superb"}`,

    cName: "sub-nav",
  },
  {
    title: "Other Skoda",
    suburl: "other_skoda",
    url: `/category${"/skoda/other_skoda"}`,

    cName: "sub-nav",
  },

  {
    title: "MG",

    url: `/cat${"/mg"}`,
  },
  {
    title: "X5",
    suburl: "x5",
    url: `/category${"/mg/x5"}`,

    cName: "sub-nav",
  },

  {
    title: "Hector",
    suburl: "hector",
    url: `/category${"/mg/hector"}`,

    cName: "sub-nav",
  },
  {
    title: "Hector Plus",
    suburl: "hector_plus",
    url: `/category${"/mg/hector_plus"}`,

    cName: "sub-nav",
  },
  {
    title: "Gloster",
    suburl: "gloster",
    url: `/category${"/mg/gloster"}`,

    cName: "sub-nav",
  },
  {
    title: "Astor",
    suburl: "astor",
    url: `/category${"/mg/astor"}`,

    cName: "sub-nav",
  },
  {
    title: "X6",
    suburl: "x6",
    url: `/category${"/mg/x6"}`,

    cName: "sub-nav",
  },
  {
    title: "Other MG",
    suburl: "other_mg",
    url: `/category${"/mg/other_mg"}`,

    cName: "sub-nav",
  },

  {
    title: " Land rover",
    suburl: "all_land_rover",
    url: `/category${"/land_rover/all_land_rover"}`,

    cName: "sub-nav",
  },
  {
    title: "Other Land Rover",
    suburl: "other_land_rover",
    url: `/category${"/land_rover/other_land_rover"}`,

    cName: "sub-nav",
  },

  {
    title: "Q7",
    suburl: "q7",
    url: `/category${"/audi/q7"}`,

    cName: "sub-nav",
  },
  {
    title: "Q5",
    suburl: "q5",
    url: `/category${"/audi/q5"}`,

    cName: "sub-nav",
  },
  {
    title: "Q3",
    suburl: "q3",
    url: `/category${"/audi/q3"}`,

    cName: "sub-nav",
  },
  {
    title: "A6",
    suburl: "a6",
    url: `/category${"/audi/a6"}`,

    cName: "sub-nav",
  },
  {
    title: "A4",
    suburl: "a4",
    url: `/category${"/audi/a4"}`,

    cName: "sub-nav",
  },
  {
    title: "A3",
    suburl: "a3",
    url: `/category${"/audi/a3"}`,

    cName: "sub-nav",
  },
  {
    title: "Audi",
    suburl: "all_audi",
    url: `/category${"/audi/all_audi"}`,

    cName: "sub-nav",
  },
  {
    title: "Other Audi",
    suburl: "other_audi",
    url: `/category${"/audi/other_audi"}`,

    cName: "sub-nav",
  },

  {
    title: " Volvo",
    suburl: "all_volvo",
    url: `/category${"/volvo/all_volvo"}`,

    cName: "sub-nav",
  },
  {
    title: "S60",
    suburl: "s60",
    url: `/category${"/volvo/s60"}`,

    cName: "sub-nav",
  },
  {
    title: "S40",
    suburl: "s40",
    url: `/category${"/volvo/s40"}`,

    cName: "sub-nav",
  },
  {
    title: "S90",
    suburl: "s90",
    url: `/category${"/volvo/s90"}`,

    cName: "sub-nav",
  },
  {
    title: "S80",
    suburl: "s80",
    url: `/category${"/volvo/s80"}`,

    cName: "sub-nav",
  },
  {
    title: "Other Volvo",
    suburl: "other_volvo",
    url: `/category${"/volvo/other_volvo"}`,

    cName: "sub-nav",
  },

  {
    title: "Renault",
    url: `/cat${"/renault"}`,
  },
  {
    title: " renault",
    suburl: "all_renault",
    url: `/category${"/renault/all_renault"}`,

    cName: "sub-nav",
  },
  {
    title: "Clio",
    suburl: "clio",
    url: `/category${"/renault/clio"}`,

    cName: "sub-nav",
  },
  {
    title: "Megane",
    suburl: "megane",
    url: `/category${"/renault/megane"}`,

    cName: "sub-nav",
  },
  {
    title: "Other Renault",
    suburl: "other_renault",
    url: `/category${"/renault/other_renault"}`,

    cName: "sub-nav",
  },

  {
    title: " Jeep",
    suburl: "all_jeep",
    url: `/category${"/jeep/all_jeep"}`,

    cName: "sub-nav",
  },

  {
    title: "Cherokee",
    suburl: "cherokee",
    url: `/category${"/jeep/cherokee"}`,

    cName: "sub-nav",
  },
  {
    title: "Wrangler",
    suburl: "wrangler",
    url: `/category${"/jeep/wrangler"}`,

    cName: "sub-nav",
  },
  {
    title: "Other Jeep",
    suburl: "other_jeep",
    url: `/category${"/jeep/other_jeep"}`,

    cName: "sub-nav",
  },

  {
    title: "Ford",
    url: "ford",
  },
  {
    title: "Freestyle",
    suburl: "freestyle",
    url: `/category${"/ford/freestyle"}`,

    cName: "sub-nav",
  },
  {
    title: "Figo Aspire",
    suburl: "figo_aspire",
    url: `/category${"/ford/figo_aspire"}`,

    cName: "sub-nav",
  },
  {
    title: "Figo",
    suburl: "figo",
    url: `/category${"/ford/figo"}`,

    cName: "sub-nav",
  },
  {
    title: "Endeavour",
    suburl: "endeavour",
    url: `/category${"/ford/endeavour"}`,

    cName: "sub-nav",
  },
  {
    title: "EcoSport",
    suburl: "ecosport",
    url: `/category${"/ford/ecosport"}`,

    cName: "sub-nav",
  },
  {
    title: "EcoSport",
    suburl: "ecosport",
    url: `/category${"/ford/ecosport"}`,

    cName: "sub-nav",
  },
  {
    title: "Other Ford",
    suburl: "other_ford",
    url: `/category${"/ford/other_ford"}`,

    cName: "sub-nav",
  },

  {
    title: "Jaguar",
    url: "jaguar",
  },
  {
    title: "other jaguar",
    suburl: "other_jaguar",
    url: `/category${"/jaguar/other_jaguar"}`,

    cName: "sub-nav",
  },
  {
    title: "F-Type",
    suburl: "f_type",
    url: `/category${"/jaguar/f_type"}`,

    cName: "sub-nav",
  },
  {
    title: "XF",
    suburl: "xf",
    url: `/category${"/jaguar/xf"}`,

    cName: "sub-nav",
  },
  {
    title: "XJ",
    suburl: "xj",
    url: `/category${"/jaguar/xj"}`,

    cName: "sub-nav",
  },
  {
    title: "XK",
    suburl: "xk",
    url: `/category${"/jaguar/xk"}`,

    cName: "sub-nav",
  },

  {
    title: "other car models",
    suburl: "other_car_models",
    url: `/category${"/other_car_models/other_car_models"}`,

    cName: "sub-nav",
  },
];
